// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"0fb818e7","540":"b843898b"}[chunkId] + ".chunk.js";
};